import { createTheme } from "@mui/material";

const theme = createTheme({
    palette: {
        mode: 'light',
        primary: {
            main: '#2A307D',
        },
        secondary: {
            main: '#191C4A',
        }
    }
});

export default theme